import React, { useState } from 'react'
import ReactFullscreen from "react-full-screen";


const SequenceResume = ({ rank, result }) => {

    const [fullscreen, setFullScreen] = useState(false)

    const { resource, points } = result;


    return (
        <div className="col-xs-12 col-sm-6 col-lg-4">
            <div className="row pair-comparison-resume">
                <div className="col-xs-12 no-p-l-r resource">
                    <div className="resource">
                        {resource.type !== "VIDEO" && (
                            <ReactFullscreen enabled={fullscreen}>
                                <span className="helper-img"></span>
                                <img
                                    className="img-responsive cursor-pointer img-center"
                                    alt="Resource (Pair comparaison)"
                                    src={resource.downloadURL}
                                    onClick={() => setFullScreen(!fullscreen)}
                                />
                            </ReactFullscreen>
                        )}
                        {resource.type === "VIDEO" && (
                            <video
                                className="img-responsive"
                                alt="Resource (Pair comparaison)"
                                src={resource.downloadURL}
                                controls
                                muted
                            />
                        )}
                    </div>

                </div>
                <div className="col-xs-12 infos infosCodifab">
                    <div className="metadata">
                        <div className="label">Rang</div>
                        <div className="value">{rank}</div>
                    </div>
                    <div className="metadata">
                        <div className="label">Points</div>
                        <div className="value">{points}</div>
                    </div>
                    <div className="metadata">
                        <div className="label">Indice d'ouverture</div>
                        <div className="value">{resource.name}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SequenceResume
